var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconIcon120(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons=Icons120"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6875 11.0177C20.23 15.2633 17.228 19.145 12.9823 19.6875C11.2352 19.9107 9.5498 19.5338 8.1333 18.717L17.2819 6.32842C18.562 7.51926 19.4485 9.14785 19.6875 11.0177ZM6.47119 17.4315L16.1611 5.4616C14.6866 4.52212 12.8874 4.07358 11.0176 4.31251C6.77196 4.85505 3.76996 8.73667 4.3125 12.9823C4.53575 14.7294 5.32442 16.2659 6.47119 17.4315ZM21.6713 10.7641C22.3539 16.1055 18.5772 20.9888 13.2358 21.6714C7.89451 22.3539 3.01118 18.5772 2.32863 13.2359C1.64609 7.89452 5.42279 3.01119 10.7641 2.32864C16.1055 1.6461 20.9888 5.4228 21.6713 10.7641Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIcon120);
export default __webpack_public_path__ + "static/media/icon-icon120.cf2210bb47edcaa466ff6d2f059be8ac.svg";
export { ForwardRef as ReactComponent };